module.exports = __webpack_public_path__ + "static/media/add_material_icon.abf3f099.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add_material_icon.png
// module id = 1494
// module chunks = 0